// extracted by mini-css-extract-plugin
export default {"Select":"CustomSelect_Select__p20E5","required":"CustomSelect_required__Rccyl"};